import { getConversation, isConversationUnread } from 'conversations/modules/conversation/selectors'
import { getCurrentUserId } from 'conversations/modules/user/selectors'
import { decrementBadgeCount, incrementBadgeCount } from 'shared/store/actions/conversation'
import Conversation from 'shared/typings/conversations/Conversation'

import { GlobalStore as store } from '@driftt/traffic-control'

export const isConversationMine = (conversation: Conversation): boolean => {
  const currentUserId = getCurrentUserId(store.getState())
  return conversation.participantIds.includes(currentUserId ?? 0)
}

const getIsUnread = (conversation: Conversation): boolean => {
  return isConversationUnread(conversation)(store.getState())
}

export const updateBadgeCounts = (conversation: Conversation): any => {
  if (!conversation) return

  const oldConversation = getConversation(conversation.id)(store.getState())
  const isMyConvo = isConversationMine(conversation)
  const inboxId = conversation.inboxId
  const conversationId = conversation.id
  const updatedAt = conversation.updatedAt
  const newIsClosed = conversation.status === 'CLOSED'

  // conversation already exists
  if (oldConversation) {
    const oldIsMyConvo = isConversationMine(oldConversation)
    const newMessage = getIsUnread(conversation) && !getIsUnread(oldConversation)
    const stillUnread = getIsUnread(conversation) && getIsUnread(oldConversation)

    const oldIsClosed = oldConversation.status === 'CLOSED'
    const alreadyClosed = oldIsClosed && newIsClosed
    const convoClosed = newIsClosed && !oldIsClosed

    switch (true) {
      case alreadyClosed: // don't badge for closed conversations
        break
      case oldIsMyConvo && !isMyConvo: // left conversation
      case convoClosed:
        return decrementBadgeCount({ inboxId, conversationId })
      case !oldIsMyConvo && isMyConvo && newMessage: // joined conversation that has unread message
      case !oldIsMyConvo && isMyConvo && stillUnread: // direct chat wasn't mine until update, message is still unread
      case isMyConvo && newMessage && !stillUnread: // new message, don't increment if there were already unread messages
        return incrementBadgeCount({ inboxId, conversationId, updatedAt })
      default:
        break
    }
  } else if (isMyConvo && !newIsClosed && getIsUnread(conversation)) {
    // new open convo routed to me with a new message
    return incrementBadgeCount({ inboxId, conversationId, updatedAt })
  }
}
